import { Phone, MessageCircle, CalendarClock } from "lucide-react";
import { Link } from "react-router-dom";
import { CONFIG } from "@/lib/api";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 pb-safe-mobile"
    >
      <div className="glass-strong border-t border-white/10 grid grid-cols-3">
        <a
          data-testid="mcta-call"
          href={`tel:${CONFIG.phoneRaw}`}
          className="flex flex-col items-center justify-center py-3 text-[color:var(--pcv-text)] hover:text-[color:var(--pcv-gold)]"
        >
          <Phone className="w-4 h-4 mb-1" />
          <span className="text-[10px] uppercase tracking-widest">Call</span>
        </a>
        <a
          data-testid="mcta-whatsapp"
          href={`https://wa.me/${CONFIG.whatsapp}`}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center justify-center py-3 border-x border-white/10 text-[color:var(--pcv-wa)]"
        >
          <MessageCircle className="w-4 h-4 mb-1" />
          <span className="text-[10px] uppercase tracking-widest">WhatsApp</span>
        </a>
        <Link
          data-testid="mcta-visit"
          to="/contact"
          className="flex flex-col items-center justify-center py-3 bg-[color:var(--pcv-gold)] text-[color:var(--pcv-bg)]"
        >
          <CalendarClock className="w-4 h-4 mb-1" />
          <span className="text-[10px] uppercase tracking-widest">Book Visit</span>
        </Link>
      </div>
    </div>
  );
}
